<i class="material-icons iconHelp" (click)="openModal()">help</i>
<router-outlet></router-outlet>
<ngx-spinner color="#FF8200" type="ball-fall"></ngx-spinner>